import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[libCarouselItem]',
    standalone: false
})
export class CarouselItemDirective {
  public itemTemplate: TemplateRef<any>;

  constructor(private templateRef: TemplateRef<any>) {
    this.itemTemplate = this.templateRef;
  }
}
